/*
 * Module for the taxability tab of Benefit Summary screens
*/

rs.module("framework/benefitsummary/taxability",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, calculationMethods) {

            var taxabilityTab = $.js(jsSelectors.taxabilityTab);

            // recalc the tax excluded amount when link is clicked
            taxabilityTab.js(jsSelectors.recalcTaxExcludeLink).click(function () {

                taxabilityTab.js(jsSelectors.taxExcludeSpinner).show();

                $.get(backendUrls.getBaseTaxExcluded,
                    {
                        appliedExcludedPercent: taxabilityTab.js(jsSelectors.overridePercentage).val(),
                        baseBenefitAmount: taxabilityTab.js(jsSelectors.baseBenefitAmount).val()
                    })
                    .done(function (result) {

                        taxabilityTab.js(jsSelectors.taxExcludedAmount).html(result.taxExcludedAmount);

                        taxabilityTab.js(jsSelectors.taxExcludeSpinner).hide();
                    })
                    .fail(function () {
                        taxabilityTab.js(jsSelectors.taxExcludeSpinner).hide();
                    });
            });

            // on calculation method change, reload tax free fields
            taxabilityTab.js(jsSelectors.taxFreeMethodSelect).change(function () {

                // default tax free amount
                taxabilityTab.js(jsSelectors.taxFreeAmount).val("$0.00").clearErrors();
                taxabilityTab.js(jsSelectors.taxFreeAmountHidden).val("$0.00");

                // default tax free percent
                taxabilityTab.js(jsSelectors.taxFreePercent).val("0.00000%").clearErrors();
                taxabilityTab.js(jsSelectors.taxFreePercentHidden).val("0.00000%");

                taxabilityTab.js(jsSelectors.recalcSimplifiedLink).hide();

                // Get selected calculation method
                var calcMethod = $(this).val();

                if (calcMethod == calculationMethods.userInput) {

                    taxabilityTab.js(jsSelectors.taxFreeAmount).prop("disabled", false);
                    taxabilityTab.js(jsSelectors.taxFreePercent).prop("disabled", false);
                }
                else if (calcMethod == calculationMethods.notCalculated) {

                    taxabilityTab.js(jsSelectors.taxFreeAmount).prop("disabled", true);
                    taxabilityTab.js(jsSelectors.taxFreePercent).prop("disabled", true);
                }
                else if (calcMethod == calculationMethods.simplified) {

                    _getSimplifiedTaxFree();
                }                
            });

            // recalc simplified tax free amount on click
            taxabilityTab.js(jsSelectors.recalcSimplifiedLink).click(_getSimplifiedTaxFree);

            // clear tax free percent when tax free amount is entered
            taxabilityTab.js(jsSelectors.taxFreeAmount).keypress(function () {
                taxabilityTab.js(jsSelectors.taxFreePercent).val("0.00000%").clearErrors();
            });

            // clear tax free amount when tax free percent is entered
            taxabilityTab.js(jsSelectors.taxFreePercent).keypress(function () {
                taxabilityTab.js(jsSelectors.taxFreeAmount).val("$0.00").clearErrors();
            });

            //
            // Calculate simplified tax free amount and update inputs
            //
            function _getSimplifiedTaxFree() {

                taxabilityTab.js(jsSelectors.simplifiedSpinner).show();

                $.get(backendUrls.getSimplifiedTaxFree, {})
                    .done(function (result) {

                        taxabilityTab.js(jsSelectors.taxFreeAmount).val(result.taxFreeAmount);
                        taxabilityTab.js(jsSelectors.taxFreeAmountHidden).val(result.taxFreeAmount);

                        taxabilityTab.js(jsSelectors.taxFreeAmount).prop("disabled", true);
                        taxabilityTab.js(jsSelectors.taxFreePercent).prop("disabled", true);
                        taxabilityTab.js(jsSelectors.recalcSimplifiedLink).show();

                        taxabilityTab.js(jsSelectors.simplifiedSpinner).hide();
                    })
                    .fail(function () {
                        taxabilityTab.js(jsSelectors.simplifiedSpinner).hide();
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);